// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ChartSquareIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ChartSquare/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.492 1.667H6.508c-3.033 0-4.841 1.808-4.841 4.841v6.975c0 3.042 1.808 4.85 4.841 4.85h6.975c3.034 0 4.842-1.808 4.842-4.841V6.508c.008-3.033-1.8-4.841-4.833-4.841Zm-5.9 12.416a.413.413 0 0 1-.417.417H4.85a.413.413 0 0 1-.417-.417v-3.85a.95.95 0 0 1 .95-.95h1.792c.233 0 .417.184.417.417v4.383Zm3.983 0a.413.413 0 0 1-.417.417H8.833a.413.413 0 0 1-.416-.417V6.45a.95.95 0 0 1 .95-.95h1.266a.95.95 0 0 1 .95.95v7.633h-.008Zm3.992 0a.413.413 0 0 1-.417.417h-2.325a.413.413 0 0 1-.417-.417v-2.958c0-.233.184-.417.417-.417h1.792a.95.95 0 0 1 .95.95v2.425Z"
}));
export default ChartSquareIcon;